import { render, staticRenderFns } from "./ConsigneeContactEntryModal.vue?vue&type=template&id=2b97c665"
import script from "./ConsigneeContactEntryModal.vue?vue&type=script&lang=ts"
export * from "./ConsigneeContactEntryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports